/* Körven Studio — favoris (stockage local, synchronisation des cœurs et du compteur) */
(function () {
  var KEY = 'ks-wishlist-v1';
  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (i) { return i && typeof i.h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('ks-wishlist:change', { detail: { list: list } }));
  }
  function has(h) { return read().some(function (i) { return i.h === h; }); }
  function add(h) {
    var l = read().filter(function (i) { return i.h !== h; });
    l.unshift({ h: h, t: Date.now() });
    write(l);
  }
  function remove(h) { write(read().filter(function (i) { return i.h !== h; })); }
  function setVariant(h, v) {
    write(read().map(function (i) { return i.h === h ? { h: i.h, t: i.t, v: v } : i; }));
  }
  function sync() {
    var l = read();
    var set = {};
    l.forEach(function (i) { set[i.h] = true; });
    document.querySelectorAll('[data-ks-wl]').forEach(function (b) {
      var on = !!set[b.getAttribute('data-ks-wl')];
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
      var lbl = on ? b.getAttribute('data-label-remove') : b.getAttribute('data-label-add');
      if (lbl && b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
    });
    document.querySelectorAll('[data-ks-wl-dot]').forEach(function (d) {
      if (d.classList.contains('is-visible') !== (l.length > 0)) d.classList.toggle('is-visible', l.length > 0);
    });
    document.querySelectorAll('[data-ks-wl-count]').forEach(function (c) {
      var t = String(l.length);
      if (c.textContent !== t) c.textContent = t;
      if (c.hidden !== (l.length === 0)) c.hidden = l.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ks-wl]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-ks-wl');
    if (has(h)) {
      remove(h);
    } else {
      add(h);
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  window.KSWishlist = { read: read, write: write, add: add, remove: remove, has: has, setVariant: setVariant, sync: sync };
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 60); }
  function start() {
    sync();
    if ('MutationObserver' in window) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
